var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60.845,
    viewBox: "0 0 60 60.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(-530 -4472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 60,
    height: 60.845,
    rx: 12,
    transform: "translate(530 4472)",
    fill: "#f5f6fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-call-1322477",
    transform: "translate(534.146 4475.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M20.995,35.29a28.573,28.573,0,0,0,7.7,4.52.756.756,0,0,0,.523-1.42,28.113,28.113,0,0,1-7.247-4.221c-4.744-4.184-7.06-7.583-8.144-9.713a10.274,10.274,0,0,1-1.233-3.624v-.149a7.961,7.961,0,0,1,2.279-7.658A1.766,1.766,0,0,1,17,12.8l4.259,4.184a1.879,1.879,0,0,1,.635,1.345,2.172,2.172,0,0,1-.635,1.307l-.037.037-1.98,1.98a.691.691,0,0,0-.149.822,22.921,22.921,0,0,0,7.845,8.891l1.009.672c.859.523,1.382.822,1.42.822a.729.729,0,0,0,.859-.112l2.5-2.466a1.329,1.329,0,0,1,1.718.037l.037.037,4.333,4.221a1.909,1.909,0,0,1,.523,1.457,1.767,1.767,0,0,1-.56,1.009l-.112.112a6.5,6.5,0,0,1-6.089,2.129.748.748,0,1,0-.336,1.457,8.04,8.04,0,0,0,1.457.149,7.841,7.841,0,0,0,6.052-2.69,3.011,3.011,0,0,0,1.083-1.943,3.6,3.6,0,0,0-.859-2.652l-.075-.075-4.371-4.259a2.83,2.83,0,0,0-3.661-.261l-.112.112-2.167,2.129c-.224-.112-.486-.3-.822-.486s-.635-.411-.971-.635a22.209,22.209,0,0,1-7.172-7.807l1.606-1.606A3.411,3.411,0,0,0,23.348,18.4a3.357,3.357,0,0,0-1.083-2.466l-4.3-4.3c-.037-.037-.075-.037-.075-.075a3.233,3.233,0,0,0-4,.3,9.515,9.515,0,0,0-2.8,9.078C11.17,21.692,11.843,27.3,20.995,35.29Z",
    fill: "#ffaa2f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ae16ac96bc5726c57e69482331b27a8d.svg";
export { ForwardRef as ReactComponent };